var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.319 4.431 8.499 18.249a1 1 0 0 1-1.416 0L1.739 12.9a1 1 0 0 0-1.635.325 1 1 0 0 0 .218 1.092l5.346 5.345a3.01 3.01 0 0 0 4.25 0L23.736 5.847a1 1 0 1 0-1.417-1.416"
  })));
};
export default SvgCheck;